module.exports = __webpack_public_path__ + "img/6 Helmut (1).jpg";